import brokerfirmService from "../services/brokerfirm.service";

const brokerfirms = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        create(_, formData) {
            return brokerfirmService.create(formData);
        },
        addNote(_, params) {
            return brokerfirmService.addNote(params.brokerfirmId, params.text);
        },
        //READ
        get(_, params) {
            return brokerfirmService.get(params.id, params.urlParameters, params.requestId);
        },
        getlist() {
            return brokerfirmService.getlist();
        },
        comissionreport(_, params) {
            return brokerfirmService.comissionReport(params.fromDate, params.toDate);
        },
        //UPDATE
        update(_, params) {
            return brokerfirmService.update(params.id, params.formData);
        },
        //DELETE
        delete(_, id) {
            return brokerfirmService.delete(id);
        },
    },
    getters: {},
    mutations: {},
};

export default brokerfirms;
